import React from 'react';

const CartSuccessPopup = ({ product, onContinueShopping, onGoToCart, onBuyNow }) => {
  if (!product) return null;
  const optionsString = product?.options
    ? Object.entries(product.options)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ')
    : '';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
   
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl animate-fade-in-down">
        <div className="p-4 border-b flex justify-between items-center">
             <h2 className="text-lg font-semibold text-green-600 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 inline-block mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Successfully Added to Cart
            </h2>
            <button onClick={onContinueShopping} className="text-white-400 hover:bg-orange-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        
        
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-center space-x-4">
                <img src={product.image_url} alt={product.product_name} className="w-24 h-24 object-cover rounded-md shadow-md"/>
                <div>
                    <h3 className="font-bold text-gray-800">{product.product_name}</h3>
                    <p className="text-sm text-gray-600 capitalize">{optionsString}</p>
                    <p className="text-lg font-semibold text-gray-900 mt-2">
                        {/* ₹{product.unit_selling_price} */}
                         ₹{Number(product.unit_selling_price).toFixed(2)}
                        </p>
                </div>
            </div>

            <div className="flex flex-col justify-center space-y-3">
                <button
                    onClick={onGoToCart}
                    className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded-lg transition-colors"
                >
                    Go to Cart
                </button>
                <button
                    onClick={onBuyNow}
                    className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded-lg transition-colors"
                >
                    {/* Buy Now */}
                    Proceed to Buy
                </button>
                 <button
                    onClick={onContinueShopping}
                    className="w-full bg-transparent hover:bg-gray-100 text-gray-700 font-semibold py-2 px-4 rounded-lg border border-gray-300 transition-colors"
                >
                    Continue Shopping
                </button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default CartSuccessPopup;